/**
 * Generated by orval 🍺
 * Do not edit manually.
 * GTA CRM Demo API
 * GTA CRM 生产级 demo 的只读+轻写 API(feat-008;demo-scoped,零 model 零迁移)。
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `global` - 全球区
 * * `china` - 中国区
 */
export type RegionEnum = (typeof RegionEnum)[keyof typeof RegionEnum];

export const RegionEnum = {
  global: "global",
  china: "china",
} as const;
